import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../services/api';

import { Botton, Container, ContainerAgreements } from './styles';
import { customerAgreementAccepted } from '../../store/modules/auth/actions';

const Agreement: React.FC = () => {
  const [agreements, setAgreements] = useState("");
  const [agreementId, setAgreementId] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    async function getAgreements() {
      try {
        const { data } = await api.post('/layout/agreements', {
          "type": "1"
        });
        setAgreements(data.data.content);
        setAgreementId(data.data.id);
      } catch (error) {
        alert("Ocorreu um erro ao buscar os termos");
      }
    }
    getAgreements();
  }, []);

  const handleAgreementAccepted = useCallback(async () => {
    dispatch(customerAgreementAccepted(agreementId));
  }, [agreementId, dispatch]);

  return (
    <Container>
      <ContainerAgreements dangerouslySetInnerHTML={{
        __html: agreements && agreements
      }} />
       {/* <AgreementsModal /> */}
      <Botton onClick={() => handleAgreementAccepted()}><span>Aceito</span></Botton>
    </Container>
  );
}

export default Agreement;
